import { storyblokEditable } from "@storyblok/react";
import { render } from "storyblok-rich-text-react-renderer";

import Button from "@/components/Button";
import Input from "@/components/Input";
import type { InputHook } from "@/types/utility";

import type { NewsletterBlok } from "./Newsletter";
import styles from "./newsletter.module.scss";

interface UIProps {
  blok: NewsletterBlok;
  email: InputHook;
  handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
  success: boolean;
  error: boolean;
}

const UI = ({ blok, email, handleSubmit, success, error }: UIProps) => {
  if (!blok) return null;

  return (
    <div className={styles.container} {...storyblokEditable(blok)}>
      <form onSubmit={handleSubmit} className={styles.form}>
        {blok.title && <h2 className={styles.title}>{blok.title}</h2>}
        {blok.text && <div className={styles.text}>{render(blok.text)}</div>}
        <Input
          {...email}
          placeholder="Email"
          message={
            success
              ? blok.successMessage || "Thank you for subscribing!"
              : "Something went wrong"
          }
          required
          success={success}
          validate={error}
          disabled={success}
          isValid={success}
        />
        <Button type="submit">{blok.buttonText || "Submit"}</Button>
      </form>
    </div>
  );
};

export default UI;
